var _defs, _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.64,
    height: 19.62,
    viewBox: "0 0 22.64 19.62"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#717375;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "requirement")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.51 10.05 8.55 14.09 21.89 0.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.93,8.6v7.87a2.4,2.4,0,0,1-2.4,2.4H3.15a2.39,2.39,0,0,1-2.4-2.4V5.09A2.39,2.39,0,0,1,3.15,2.7H14.53a2.39,2.39,0,0,1,1.7.7"
  })))));
}

export default SvgCheckbox;